import React, { useState, useEffect, useRef } from "react";
import { Card, CardBody, Row, Col, Button } from "reactstrap";
import Chart from "react-apexcharts";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { LOCAL_URL } from "../../constant/constant";
import html2canvas from "html2canvas";
import { Table } from "react-bootstrap";
import moment from "moment";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import * as XLSX from "sheetjs-style";

const SalesChartP = () => {
  const [services, setServices] = useState([]);
  const [mergedPricing, setmergedPricing] = useState([]);
  const [peopleModalOpen, setPeopleModalOpen] = useState(false);
  const [peopleCount, setPeopleCount] = useState("");
  const [peopleDate, setPeopleDate] = useState(moment().format("YYYY-MM-DD"));
  const [excelModalOpen, setExcelModalOpen] = useState(false);
  const [excelDate, setExcelDate] = useState(moment().format("YYYY-MM"));

  const [startDate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment().endOf("month").format("YYYY-MM-DD")
  );
  const dashboardRef = useRef(null);

  function mergePricing(pricingArray) {
    const merged = {};

    pricingArray.forEach((item) => {
      const key = item.desc;

      if (!merged[key]) {
        merged[key] = { ...item };
      } else {
        merged[key].total_tickets += item.total_tickets;
        merged[key].total_price += item.total_price;
        merged[key].total_refund += item.total_refund;
        merged[key].total_refund_amount += item.total_refund_amount;
      }
    });

    return Object.values(merged);
  }
  const getTour = async () => {
    try {
      let url = `${LOCAL_URL}patriata_api/get_dashboard_stats?startDate=${startDate}&endDate=${endDate}`;
      let response = await fetch(url);
      const data = await response.json();
      console.log(data);
      setServices(data.data);
    } catch (error) {
      console.error("Error fetching reservations:", error);
    }
  };

  const handlePeopleSubmit = async () => {
    try {
      // Construct the URL with query parameters

      let url =
        LOCAL_URL +
        `patriata_api/add_people?date=${peopleDate}&count_date=${peopleCount}`;
      let response = await fetch(url);
      const result = await response.json();
      console.log(result);
      if (result.status == 200) {
        alert("People count added successfully!");
        setPeopleModalOpen(false);
        setPeopleCount("");
      } else {
        alert("Failed to add people count.");
      }
    } catch (err) {
      console.error("Error submitting people count:", err);
      alert("An error occurred.");
    }
  };

  useEffect(() => {
    getTour();
  }, []);
  useEffect(() => {
    getTour();
  }, [startDate, endDate]);

  // const processData = () => {
  //   let totalRevenue = 0;
  //   let totalRefund = 0;
  //   let totalTickets = 0;
  //   let totalFreeTickets = 0;
  //   let totalRefundPrice = 0;

  //   services.forEach((service) => {
  //     totalFreeTickets += service?.pricing
  //       ?.filter((i) => i.price === 0)
  //       .reduce((sum, it) => sum + it.total_tickets, 0);
  //     totalRefundPrice += service?.pricing?.reduce(
  //       (sum, item) => sum + item.total_refund_amount,
  //       0
  //     );
  //     service.pricing?.forEach((item) => {
  //       totalTickets += item.total_tickets || 0;
  //       totalRevenue += item.total_price || 0;
  //       totalRefund += item.total_refund || 0;
  //     });
  //   });

  //   return {
  //     totalRevenue,
  //     totalRefund,
  //     totalTickets,
  //     totalFreeTickets,
  //     netRevenue: totalRevenue - totalRefundPrice,
  //     totalRefundPrice,
  //   };
  // };

  // const {
  //   totalRevenue,
  //   totalRefund,
  //   netRevenue,
  //   totalTickets,
  //   totalFreeTickets,
  //   totalRefundPrice,
  // } = processData();

  const downloadPDF = async () => {
    const pdf = new jsPDF("p", "mm", "a4");
    const input = dashboardRef.current;

    // Scroll fix: Wait until all images are fully loaded
    await new Promise((resolve) => setTimeout(resolve, 1000));

    // Capture each graph separately to avoid cutoff
    const graphElements = input.querySelectorAll(".graph-container");

    for (let i = 0; i < graphElements.length; i++) {
      const canvas = await html2canvas(graphElements[i], { scale: 2 });
      const imgData = canvas.toDataURL("image/png");
      const imgWidth = 190;
      const pageHeight = 297;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      if (i > 0) pdf.addPage();
      pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);
    }

    pdf.save("dashboard_report.pdf");
  };

  const handleDownloadExcel = async () => {
    try {
      let url = `${LOCAL_URL}patriata_api/excel_stats?date=${excelDate}`;
      const response = await fetch(url);
      const result = await response.json();
  
      const { types, data } = result.data;
  
      // Header Rows
      const row1 = ["Date"];
      const row2 = [""];
  
      types.forEach((type) => {
        row1.push(type, "");
        row2.push("Tickets", "Revenue");
      });
  
      row1.push(
        "Gross Total", "", "Total Refunded", "", "Net Total", "",
        "People Counter", "Difference"
      );
      row2.push(
        "Tickets", "Revenue", "Tickets", "Revenue", "Tickets", "Revenue", "", ""
      );
  
      const sheetData = [row1, row2];
  
      // Data Rows
      data.forEach((entry) => {
        const row = [entry.date?.trim() ?? "-"];
        types.forEach((type) => {
          const item = entry.types[type] || {};
          row.push(item.tickets ?? "-", item.revenue ?? "-");
        });
        row.push(
          entry.gross_tickets ?? "-",
          entry.gross_revenue ?? "-",
          entry.refunded_tickets ?? "-",
          entry.refunded_amount ?? "-",
          entry.net_tickets ?? "-",
          entry.net_revenue ?? "-",
          entry.people_counter ?? "-",
          entry.difference ?? "-"
        );
        sheetData.push(row);
      });
  
      // Totals Row
      const totalRow = ["Line Totals"];
      types.forEach((type) => {
        let totalTickets = 0;
        let totalRevenue = 0;
        data.forEach((entry) => {
          const t = entry.types[type];
          if (t) {
            totalTickets += t.tickets || 0;
            totalRevenue += t.revenue || 0;
          }
        });
        totalRow.push(totalTickets ?? "-", totalRevenue ?? "-");
      });
  
      const totalGrossTickets = data.reduce((acc, e) => acc + (e.gross_tickets || 0), 0);
      const totalGrossRevenue = data.reduce((acc, e) => acc + (e.gross_revenue || 0), 0);
      const totalRefundedTickets = data.reduce((acc, e) => acc + (e.refunded_tickets || 0), 0);
      const totalRefundedAmount = data.reduce((acc, e) => acc + (e.refunded_amount || 0), 0);
      const totalNetTickets = data.reduce((acc, e) => acc + (e.net_tickets || 0), 0);
      const totalNetRevenue = data.reduce((acc, e) => acc + (e.net_revenue || 0), 0);
      const totalPeople = data.reduce((acc, e) => acc + (e.people_counter || 0), 0);
      const totalDiff = data.reduce((acc, e) => acc + (e.difference || 0), 0);
  
      totalRow.push(
        totalGrossTickets ?? "-",
        totalGrossRevenue ?? "-",
        totalRefundedTickets ?? "-",
        totalRefundedAmount ?? "-",
        totalNetTickets ?? "-",
        totalNetRevenue ?? "-",
        totalPeople ?? "-",
        totalDiff ?? "-"
      );
  
      sheetData.push(totalRow);
  
      // Create worksheet
      const ws = XLSX.utils.aoa_to_sheet(sheetData);
  
      // Merge Header Cells
      const merges = [];
      let colIndex = 1;
      types.forEach(() => {
        merges.push({ s: { r: 0, c: colIndex }, e: { r: 0, c: colIndex + 1 } });
        colIndex += 2;
      });
      merges.push({ s: { r: 0, c: colIndex }, e: { r: 0, c: colIndex + 1 } }); // Gross
      colIndex += 2;
      merges.push({ s: { r: 0, c: colIndex }, e: { r: 0, c: colIndex + 1 } }); // Refunded
      colIndex += 2;
      merges.push({ s: { r: 0, c: colIndex }, e: { r: 0, c: colIndex + 1 } }); // Net
  
      ws["!merges"] = merges;
  
      // Styling
      const boldCenter = {
        alignment: { horizontal: "center", vertical: "center" },
        font: { bold: true },
      };
      const center = {
        alignment: { horizontal: "center", vertical: "center" },
      };
  
      sheetData.forEach((row, rIdx) => {
        row.forEach((val, cIdx) => {
          const cellRef = XLSX.utils.encode_cell({ r: rIdx, c: cIdx });
          const cell = ws[cellRef];
          if (!cell) return;
          if (rIdx <= 1 && cIdx !== 0) {
            cell.s = boldCenter;
          } else if (val === "-") {
            cell.s = center;
          } else {
            cell.s = center;
          }
        });
      });
  
      // Auto column width
      ws["!cols"] = sheetData[0].map((_, cIdx) => {
        const colVals = sheetData.map((r) => String(r[cIdx] ?? ""));
        const maxLen = Math.max(...colVals.map((v) => v.length));
        return { wch: maxLen + 2 };
      });
  
      // Export to file
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Monthly Report");
      XLSX.writeFile(wb, `Monthly_Report_${excelDate}.xlsx`);
      setExcelModalOpen(false);
    } catch (err) {
      console.error("Excel export failed", err);
      alert("Export failed");
    }
  };
  

  useEffect(() => {
    const mp = mergePricing(services.flatMap((service) => service.pricing));
    setmergedPricing(mp);
  }, [services]);
  return (
    <Row>
      <Col lg="12">
        <Card>
          <CardBody>
            <Row>
              <div className="col-md-2">
                <label className="form-label">Start Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>
              <div className="col-md-2">
                <label className="form-label">End Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>
              <div className="col-md-2 d-flex flex-column justify-content-end">
                {/* Empty label to match height */}
                <label className="form-label invisible">Placeholder</label>

                <Button color="primary" onClick={downloadPDF}>
                  Download Report
                </Button>
              </div>
              <div className="col-md-3 d-flex flex-column justify-content-end">
                {/* Empty label to match height */}
                <label className="form-label invisible">Placeholder</label>

                <Button
                  className="button_green"
                  onClick={() => setPeopleModalOpen(true)}
                >
                  Add People Count
                </Button>

                <Modal
                  isOpen={peopleModalOpen}
                  toggle={() => setPeopleModalOpen(!peopleModalOpen)}
                >
                  <div className="modal-header">
                    <h5 className="modal-title">Add People Count</h5>
                    <button
                      type="button_green"
                      className="btn-close"
                      onClick={() => setPeopleModalOpen(false)}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="mb-3">
                      <label>Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={peopleDate}
                        onChange={(e) => setPeopleDate(e.target.value)}
                      />
                    </div>
                    <div className="mb-3">
                      <label>People Count</label>
                      <input
                        type="number"
                        className="form-control"
                        value={peopleCount}
                        onChange={(e) => setPeopleCount(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="modal-footer">
                    <Button
                      color="secondary"
                      onClick={() => setPeopleModalOpen(false)}
                    >
                      Cancel
                    </Button>
                    <Button color="primary" onClick={handlePeopleSubmit}>
                      Submit
                    </Button>
                  </div>
                </Modal>
              </div>

              <div className="col-md-3 d-flex flex-column justify-content-end">
                <Button
                  color="success"
                  className="button_green"
                  onClick={() => setExcelModalOpen(true)}
                >
                  Download Monthly Report
                </Button>
                <Modal
                  isOpen={excelModalOpen}
                  toggle={() => setExcelModalOpen(false)}
                >
                  <ModalHeader toggle={() => setExcelModalOpen(false)}>
                    Download Monthly Excel Report
                  </ModalHeader>
                  <ModalBody>
                    <label>Select Month</label>
                    <input
                      type="month"
                      className="form-control"
                      value={excelDate}
                      onChange={(e) => setExcelDate(e.target.value)}
                    />
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      color="secondary"
                      onClick={() => setExcelModalOpen(false)}
                    >
                      Cancel
                    </Button>
                    <Button color="primary" onClick={handleDownloadExcel}>
                      Download
                    </Button>
                  </ModalFooter>
                </Modal>
              </div>
            </Row>
            <div id="dashboard-content" ref={dashboardRef}>
              <Row className="mt-3">
                {/* <Col md="3">
                  <Card className="p-3">
                    <h6>Total Reservations</h6>
                    <h6>({totalTickets} Tickets)</h6>

                    <h4>RS {totalRevenue}</h4>
                  </Card>
                </Col>
                <Col md="3">
                  <Card className="p-3">
                    <h6>Total Refund</h6>
                    <h6>({totalRefund} Tickets)</h6>

                    <h4>RS {totalRefundPrice}</h4>
                  </Card>
                </Col>
                <Col md="3">
                  <Card className="p-3">
                    <h6>Free Tier Tickets</h6>
                    <h6>({totalFreeTickets} Tickets)</h6>

                    <h4>RS {0}</h4>
                  </Card>
                </Col>
                <Col md="3">
                  <Card className="p-3">
                    <h6>Net Revenue</h6>
                    <h6>
                      ({totalTickets - totalRefund - totalFreeTickets} Tickets)
                    </h6>
                    <h4>RS {netRevenue}</h4>
                  </Card>
                </Col> */}

                {/* <TicketSummaryTable pricing={mergedPricing} /> */}
                <BarChartExample
                  key={"All"}
                  data={{
                    name: `TDCP Patriata Resort Murree E-Ticketing Report for [${startDate} - ${endDate}]`,
                    pricing: mergedPricing,
                  }}
                  isPricing={false}
                />
                {/* {services.length && (
                  <BarChartExample
                    key={services[0].name}
                    data={services[0]}
                    index={0}
                  />
                )} */}
              </Row>
              {services.length &&
                services.map((s, i) => (
                  <BarChartExample key={s.name} data={s} index={i} />
                ))}
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

const BarChartExample = ({ data, index, isPricing = true }) => {
  //console.log("Chart Data:", data);

  // Extract categories and corresponding data
  const categories = data?.pricing?.map((item) => item.desc) || [];
  const ticketData = data?.pricing?.map((item) => item.total_tickets) || [];
  const totalRevenue = data?.pricing?.reduce(
    (sum, item) => sum + item.total_price,
    0
  );
  const totalRefund = data?.pricing?.reduce(
    (sum, item) => sum + item.total_refund,
    0
  );
  const totalRefundPrice = data?.pricing?.reduce(
    (sum, item) => sum + item.total_refund_amount,
    0
  );
  const freeTierTickets = data?.pricing
    ?.filter((item) => item.price === 0)
    .reduce((sum, item) => sum + item.total_tickets, 0);
  const netRevenue = totalRevenue - totalRefundPrice;
  const totalTickets = ticketData.reduce((sum, val) => sum + val, 0);

  const options = {
    chart: { type: "bar" },
    // plotOptions: {
    //   bar: {
    //     horizontal: false,
    //     columnWidth: '55%',
    //     endingShape: 'rounded',
    //     colors: {
    //       backgroundBarColors: ['#02571c'],
    //       backgroundBarOpacity: 1,
    //     }
    //   },
    // },
    dataLabels: {
      enabled: true,
      position: "top", // number upar show hoga
      style: {
        colors: ["#000"], // text color
      },
      offsetY: -50, // number thoda aur upar aayega
    },
    colors: ["#02571c"], // green color

    xaxis: { categories },
  };

  const series = [
    {
      name: "Total Tickets",
      data: ticketData,
    },
  ];

  return (
    <div className={`mb_3 graph-container`}>
      <h3 className="stats_heading mb-4 text-xl fw-bold">{data?.name}</h3>

      <Row className="mt-3">
        <Col md="3">
          <Card className="p-4 text-center shadow-lg">
            {/* Total reservation (x Tickets) */}
            <h6 className="text-lg fw-bold">Total Reservations</h6>
            <h6 className="text-lg fw-bold">({totalTickets} Tickets)</h6>
            <h4>RS {totalRevenue}</h4>
          </Card>
        </Col>
        <Col md="3">
          <Card className="p-4 text-center shadow-lg">
            {/* Total refund (x Tickets) */}
            <h6 className="text-lg fw-bold">Total Refund </h6>
            <h6 className="text-lg fw-bold">
              <span className="text-muted">({totalRefund} Tickets)</span>
            </h6>
            <h4>RS {totalRefundPrice}</h4>
          </Card>
        </Col>
        <Col md="3">
          <Card className="p-4 text-center shadow-lg">
            {/* Free tier (x Tickets) price=>0 */}
            <h6 className="text-lg fw-bold">Free Tier Tickets </h6>
            <h6 className="text-lg fw-bold">
              <span className="text-muted">({freeTierTickets} Tickets)</span>
            </h6>
            <h4>RS {0}</h4>
          </Card>
        </Col>
        <Col md="3">
          <Card className="p-4 text-center shadow-lg">
            {/* Net Revenue (x Tickets) */}
            <h6 className="text-lg fw-bold">Net Revenue</h6>
            <h6 className="text-lg fw-bold">
              <span className="text-muted">
                ({totalTickets - freeTierTickets - totalRefund} Tickets)
              </span>
            </h6>
            <h4>RS {netRevenue}</h4>
          </Card>
        </Col>
      </Row>
      <TicketSummaryTable pricing={data?.pricing} isPricing={isPricing} />
      <Chart
        options={options}
        series={series}
        type="bar"
        height="350"
        className="mt-4"
      />
    </div>
  );
};

const TicketSummaryTable = ({ pricing, isPricing }) => {
  console.log("table:", pricing);

  const totalTickets = pricing.reduce((sum, item) => sum + item.total_tickets, 0);
  const totalValidTickets = pricing.reduce((sum, item) => sum + item.valid_tickets, 0);
  const totalRefunds = pricing.reduce((sum, item) => sum + item.total_refund, 0);
  const totalAmount = pricing.reduce((sum, item) => sum + item.total_price, 0);
  const refundAmount = pricing.reduce((sum, item) => sum + item.total_refund_amount, 0);
  const netAmount = totalAmount - refundAmount;

  // Optional: Calculate totals for each validation stage
  const totalBaseValidated = pricing.reduce((sum, item) => sum + (item.base_validated || 0), 0);
  const totalMidUpValidated = pricing.reduce((sum, item) => sum + (item.mid_up_validated || 0), 0);
  const totalTopValidated = pricing.reduce((sum, item) => sum + (item.top_validated || 0), 0);
  const totalMidDownValidated = pricing.reduce((sum, item) => sum + (item.mid_down_validated || 0), 0);

  return (
    <Table
      bordered
      responsive
      style={{
        marginTop: "3em",
        marginBottom: "3em",
        borderCollapse: "collapse",
        fontSize: "14px",
        borderBottom: "1px solid #0000",
      }}
    >
      <thead>
        <tr style={{ backgroundColor: "#02571c", color: "#fff", fontWeight: "bold" }}>
          <th>Ticket Category</th>
          {/* {isPricing && <th>Price</th>} */}
          <th>Quantity</th>
          {/* <th>Validated</th> */}
          <th>Base</th>
          <th>Mid Up</th>
          <th>Top</th>
          <th>Mid Down</th>
          <th>Amount</th>
        </tr>
      </thead>
      <tbody>
        {pricing.map((item, index) => (
          <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff" }}>
            <td>{item.desc}</td>
            {/* {isPricing && (
              <td>{item.price ? `PKR ${item.price.toLocaleString()}` : "-"}</td>
            )} */}
            <td>{item.total_tickets}</td>
            {/* <td>{item.valid_tickets}</td> */}
            <td>{item.base_validated || 0}</td>
            <td>{item.mid_up_validated || 0}</td>
            <td>{item.top_validated || 0}</td>
            <td>{item.mid_down_validated || 0}</td>
            <td>
              {item.total_price
                ? `PKR ${item.total_price.toLocaleString()}`
                : "-"}
            </td>
          </tr>
        ))}

        <tr style={{ backgroundColor: "#f2f2f2", fontWeight: "bold" }}>
          <td colSpan={isPricing ? 1 : 1}>Sub Total</td>
          <td>{totalTickets}</td>
          {/* <td>{totalValidTickets}</td> */}
          <td>{totalBaseValidated}</td>
          <td>{totalMidUpValidated}</td>
          <td>{totalTopValidated}</td>
          <td>{totalMidDownValidated}</td>
          <td>PKR {totalAmount.toLocaleString()}</td>
        </tr>
        <tr style={{ backgroundColor: "#fff", fontWeight: "bold" }}>
          <td colSpan={isPricing ? 1 : 1 }>Refunded</td>
          <td>{totalRefunds}</td>
          <td colSpan={4}></td>
          <td>PKR {refundAmount.toLocaleString()}</td>
        </tr>
        <tr style={{ backgroundColor: "#f2f2f2", fontWeight: "bold" }}>
          <td colSpan={isPricing ? 1  : 1 }>Total</td>
          <td colSpan={5}></td>
          <td>PKR {netAmount.toLocaleString()}</td>
        </tr>
      </tbody>
    </Table>
  );
};


export default SalesChartP;
